



































import { Component, mixins } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { DatePresetTypes, Filter, FilterTypes } from '@/modules/common/filter/filter'
import collect from 'collect.js'
import AdminInvoiceCreateButton from '@/modules/invoice/components/admin/AdminInvoiceCreateButton.vue'
import {
  CampaignItemPaymentCollectionTypeInAdmin,
  CampaignItemPaymentCollectionWithModel
} from '@/modules/campaign-item-payment/models/campaign-item-payment-collection.model'
import AdminCampaignItemPaymentTableRow
  from '@/modules/campaign-item-payment/components/admin/table/AdminCampaignItemPaymentTableRow.vue'
import { InertiaQueryParamsService } from '@/modules/shared/services/inertia-query-params.service'
import {
  adminCampaignItemPaymentTableColumn
} from '@/modules/campaign-item-payment/models/columns/campaign-item-payment-table.column'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'لیست تسویه آیتم ها'
  },
  metaInfo: {
    title: 'لیست تسویه آیتم ها'
  },
  components: {
    AdminInvoiceCreateButton,
    TesTable,
    FilterRow,
    PaginationWithInput
  }
})
export default class IndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  constructor(
    private readonly queryParam: InertiaQueryParamsService
  ) {
    super()
  }

  @ProvideReactive()
  @Prop() payments: CampaignItemPaymentCollectionTypeInAdmin
  private rowComponent = AdminCampaignItemPaymentTableRow
  private columns = adminCampaignItemPaymentTableColumn()

  @ProvideReactive()
  private get campaignItemPaymentWith(): CampaignItemPaymentCollectionWithModel {
    return {
      statuses: this.payments.statuses,
      payment_types: this.payments.payment_types,
      payment_item_types: this.payments.payment_item_types
    }
  }

  private filters = [
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع آیتم',
      key: 'item_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.payments.payment_item_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع تسویه',
      key: 'payment_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.payments.payment_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.DateRange,
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.tomorrow,
        DatePresetTypes.currentWeek,
        DatePresetTypes.currentMonth,
        DatePresetTypes.custom
      ],
      title: 'تاریخ ایجاد',
      holder: 'انتخاب کنید',
      keys: {
        from: 'created_at_from',
        to: 'created_at_to'
      }
    })
  ]

  protected get model(): any {
    return this.payments
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }
}
